
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.111 10.5V8.4H4.667V5.6h5.444V3.5L14 7l-3.889 3.5zM8.556 0c.855 0 1.555.63 1.555 1.4v1.4H8.556V1.4h-7v11.2h7v-1.4h1.555v1.4c0 .77-.7 1.4-1.555 1.4h-7C.7 14 0 13.37 0 12.6V1.4C0 .63.7 0 1.556 0h7z","fill":"#263238"}})])
          )
        }
      }
    